"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var appender_base_1 = require("./appender.base");
var enums_1 = require("../enums");
var date_formatter_1 = require("../date.formatter");
var pako = require("pako");
var Buffer = require('buffer').Buffer;
var uuidv4 = require('uuid').v4;
/**
 * Writes BI Log to Jarvis.
 */
var BIRemoteAppender = /** @class */ (function (_super) {
    __extends(BIRemoteAppender, _super);
    function BIRemoteAppender() {
        var _this = _super.call(this) || this;
        _this.type = enums_1.AppenderType.BIRemote;
        return _this;
    }
    BIRemoteAppender.prototype.getAppenderName = function () { return 'BIRemoteAppender'; };
    BIRemoteAppender.prototype.action = function (message, config) {
        var headerObj = __assign({}, message.extendedParameters);
        var dataObj = headerObj.additionalFields;
        delete headerObj.additionalFields;
        var biLog = this.getBILogMessage(headerObj, dataObj, headerObj.type || '');
        if (Object.values(biLog).length === 0) {
            console.error('unable to send log due to missing fields');
            return;
        }
        if (config.requiredFields && config.requiredFields.length) {
            this.validateMessage(message, config.requiredFields);
        }
        if (!config.url) {
            var errorMessage = "Please specify URL for " + this.getAppenderName();
            console.error(errorMessage);
            return;
        }
        var logHeaders = message.logHeaders || {};
        this.sendRequest(config.url, biLog, logHeaders);
    };
    BIRemoteAppender.prototype.sendRequest = function (requestUrl, jsonMessage, logHeaders) {
        try {
            var stringifiedJSON = '';
            try {
                stringifiedJSON = JSON.stringify(jsonMessage);
            }
            catch (e) {
                console.error('Error occurred while stringfying JSON message and error is - ', e);
            }
            if (stringifiedJSON !== '') {
                var bufferObject = new Buffer.from(stringifiedJSON);
                var zippedData = new Uint8Array();
                try {
                    zippedData = pako.gzip(bufferObject);
                }
                catch (e) {
                    console.error("error in log converting to gzip format", e);
                }
                if (zippedData.length == 0)
                    return;
                var httpHeaders_1 = new Headers();
                httpHeaders_1.append('Content-Type', 'application/gzip');
                httpHeaders_1.append('Accept', '*/*');
                httpHeaders_1.append('Accept-Encoding', 'gzip, deflate, br');
                Object.entries(logHeaders).forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    return httpHeaders_1.append(key, value);
                });
                var response = fetch(requestUrl, {
                    method: 'POST',
                    headers: httpHeaders_1,
                    body: zippedData,
                }).then(function (resp) {
                    if (!resp.ok) {
                        console.error('Error occurred in sending BI Log with status ', resp.status);
                    }
                });
            }
        }
        catch (e) {
            console.error("Error: Failed to send a BI log request (Timber)", e);
        }
    };
    BIRemoteAppender.prototype.getBILogMessage = function (headerObj, dataObj, typeName) {
        var _a;
        if (headerObj === void 0) { headerObj = {}; }
        if (dataObj === void 0) { dataObj = {}; }
        var biLog = {};
        var dateFormatterlib = new date_formatter_1.dateFormatter();
        var headerData = {
            id: uuidv4(),
            timestampMachine: dateFormatterlib.getDateWithTimeZone(new Date().toISOString())
        };
        if (Object.values(headerObj).length !== 0 && Object.values(dataObj).length !== 0 && typeName !== '') {
            biLog = {
                header: __assign(__assign({}, headerData), headerObj),
                data: (_a = {}, _a[this.getTypeName(typeName || '')] = dataObj, _a)
            };
        }
        return biLog;
    };
    BIRemoteAppender.prototype.getTypeName = function (type) {
        var typeName = '';
        if (type !== '') {
            typeName = type.charAt(0).toLowerCase() + type.slice(1);
            typeName = typeName.replace('Type', '');
        }
        return typeName;
    };
    BIRemoteAppender.prototype.validateMessage = function (message, requiredFields) {
        var absentFields = [];
        Object.getOwnPropertyNames(message).forEach(function (key) {
            var value = message[key];
            if (!value && requiredFields.indexOf(key) !== -1) {
                absentFields.push(key);
            }
        });
        if (absentFields.length) {
            var errorMessage = "Following properties are required for " + this.getAppenderName() + ": " + absentFields.join(', ') + ". Please provide it";
            throw new Error(errorMessage);
        }
    };
    return BIRemoteAppender;
}(appender_base_1.Appender));
exports.BIRemoteAppender = BIRemoteAppender;
//# sourceMappingURL=appender.bi-remote.js.map